import axios from 'axios';

import { CLIENGO_API_URL } from '@/constants/environment';

export interface CliengoMe {
  name?: string;
  email?: string;
}

const REQUEST_TIMEOUT_MS = 15_000;

/**
 * Resolves the authenticated user via `GET /1.0/users/me` on the Cliengo API.
 * The JWT does NOT carry the email, so the auth gate needs this call to decide
 * whether the caller is internal Cliengo staff. Forwards the JWT as Bearer.
 */
export async function getMe(jwt: string): Promise<CliengoMe> {
  const { data } = await axios.get<CliengoMe>(
    `${CLIENGO_API_URL}/1.0/users/me`,
    {
      headers: { Authorization: `Bearer ${jwt}` },
      timeout: REQUEST_TIMEOUT_MS,
    }
  );

  return data;
}

/** Cliengo internal staff email domains. */
const INTERNAL_EMAIL_DOMAINS = ['@cliengo.com', '@leadaki.com'];

/** `true` when the email belongs to Cliengo internal staff. */
export function isInternalEmail(email?: string): boolean {
  const normalized = email?.toLowerCase();

  return Boolean(
    normalized &&
    INTERNAL_EMAIL_DOMAINS.some((domain) => normalized.endsWith(domain))
  );
}
